module.exports = __webpack_public_path__ + "award_icon.235f3c7bed12da11f134.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/assets/img/usc-store/awards/award_icon.jpg
// module id = ../../../../../src/assets/img/usc-store/awards/award_icon.jpg
// module chunks = main